import React, { useEffect, useRef } from 'react'
import { Route } from 'react-router-dom'
import { useKeycloak } from 'react-keycloak'
import { ContainedButton, Spinner } from "@fabricks/ui-components";
import styled from "styled-components";

interface ProtectedRouteProps {
    component: any
    [key: string]: any
}

const LoadingOverlay = styled.div`
    -ms-opacity: 0.9;
        background: #fff;
        display: block;
        height: 100%;
        left: 0;
        opacity: 0.9;
        position: fixed;
        top: 0;
        vertical-align: middle;
        width: 100%;
        z-index: 100000;
`

const LoadingContent = styled.div`
    margin-left: auto;
    margin-top: auto;
    -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        left: 50%;
        display: block;
        position: fixed;
        top: 50%;
        transform: translate(-50%, -55%);

        .sweet-loading {
            margin-left: 30px;
            text-align: center;
        }
`

const LoaderText  = styled.div`
    margin-top: 20px;
`

export const ProtectedRoute = ({ component: Component, ...rest }: ProtectedRouteProps) => {
    const [keycloak] = useKeycloak()
    useEffect(() => {
        if (!keycloak.authenticated) {
            const timer = setTimeout(() => {
                if (!keycloak.authenticated) {
                    keycloak.login()
                }
            }, 3000)
            return () => clearTimeout(timer)
        }
        return () => {}
    }, [keycloak.authenticated])
    return (
        <Route
            {...rest}
            render={props => {
                if (keycloak.authenticated) {
                    return <Component {...props} />
                }
                return (
                    <LoadingOverlay>
                        <LoadingContent>
                            <Spinner
                                type={"GridLoader"}
                                isLoading={true}
                                color="#467abd"
                            />
                            <LoaderText>
                                Sie werden eingeloggt...
                            </LoaderText>
                        </LoadingContent>
                    </LoadingOverlay>

                );
            }}
        />
    )
}

export default ProtectedRoute
